<ui-modal modalTitle="Select Project" size="xl" [scrollable]="true" [fullHeight]="true">

	<div class="d-flex align-items-center flex-wrap" ui-modal-header>
		<div *ngIf="isAnyFilterActive()" class="icon-clear-filters px-2 mr-3 selectable" (click)="clearAllFilters()">
			<i class="wq wq-refresh "></i>
		</div>
		<div *ngIf="labelList.length" class="mr-3 w-10r">
			<ui-checkbox-dropdown dropdownName="Label" [items]="labelList" [selectedItems]="labelFilter" [selectProp]="'id'" (selectionChange)="handleLabelChange($event)"></ui-checkbox-dropdown>
		</div>
		<div class="mr-2">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text"><i class="wq wq-search"></i></span>
				</div>
				<input *ngIf="modal?.isOpen || false" type="search" class="form-control" placeholder="Search" [(ngModel)]="projectSearchList" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
			</div>
		</div>
	</div>

	<div class="d-flex mt-n3 sticky-tabs">
		<ng-container *ngIf="projects">
			<div *ngFor="let s of statusList()" class="px-3 py-3 flex-weight-1 selectable hoverable border-bottom align-items-center border-{{statusColor(s, service.statusFilter === s, 'lightgrey')}}" [ngClass]="{ 'border-4': service.statusFilter === s }" (click)="selectStatusFilter(s)">
				<span class="text-uppercase text-small text-bold mr-2 text-{{statusColor(s, service.statusFilter === s)}}" [ngClass]="{ 'text-secondary': service.statusFilter !== s }">{{statusDescription(s)}}</span>
				<span class="badge badge-{{statusColor(s, service.statusFilter === s)}}">{{statusCount(s)}}</span>
				<div class="text-bold mt-1 text-{{statusColor(s, service.statusFilter === s)}}">{{statusTotal(s) | currency:projects.primary_currency_id}}</div>
			</div>
		</ng-container>
	</div>

	<table *ngIf="projects" class="table table-hover">
		<thead>
			<tr>
				<th class="selectable sticky" (click)="sortBy('project_no')"># <i class="{{sortClass('project_no')}}"></i></th>
				<th class="selectable sticky" (click)="sortBy('customer_name')">Customer <i class="{{sortClass('customer_name')}}"></i></th>
				<th class="selectable sticky" (click)="sortBy('user_name')">Assigned To <i class="{{sortClass('user_name')}}"></i></th>
				<th class="selectable text-center sticky">Jobs</th>
				<th class="selectable text-center sticky">Quotes / Invoices</th>
				<th class="selectable sticky" (click)="sortBy('created_datetime')">Created <i class="{{sortClass('created_datetime')}}"></i></th>
				<th class="selectable sticky" (click)="sortBy('modified_datetime')">Last Modified <i class="{{sortClass('modified_datetime')}}"></i></th>
				<th class="shrink nowrap sticky text-center">Project Status</th>
				<th class="shrink nowrap sticky">Invoice Status</th>
				<th class="shrink nowrap sticky">Label</th>
				<th class="selectable nowrap text-right sticky" (click)="sortBy('net_total')">Net total <i class="{{sortClass('net_total')}}"></i></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of statusProjects(service.statusFilter) | keywords:projectSearchList:['id', 'description', 'customer_name', 'user_name', 'status', 'project_no'] | pagination:pagination" class="selectable" (click)="selectItem(item)">
				<td class="text-secondary">{{item.project_no}}</td>
				<td>
					<div><b>{{item.customer_name}}</b></div>
					<div class="text-secondary">
						{{item.description}}
						<img *ngIf="item.zoho_id" src="assets/img/integration/zoho-crm-small.png" class="ml-1" style="height: 1em;" ngbTooltip="Zoho CRM">
					</div>
				</td>
				<td class="text-center">{{item.user_name}}</td>
				<td class="text-center text-bold no-wrap">
					<ng-container *ngIf="tab && tab === 'project_job'">
						<div class="bg-{{item.project_job_count > 0 ? 'success': 'secondary'}}-25 badge text-{{item.project_job_count > 0 ? 'success': 'secondary'}}">{{item.project_job_count}} {{item.project_job_count > 1 ? 'Jobs' : 'Job'}}</div>
					</ng-container>
					<ng-container *ngIf="tab && tab === 'service_job'">
						<div class="bg-{{item.service_job_count > 0 ? 'success': 'secondary'}}-25 badge text-{{item.service_job_count > 0 ? 'success': 'secondary'}}">{{item.service_job_count}} {{item.service_job_count > 1 ? 'Jobs' : 'Job'}}</div>
					</ng-container>
					<ng-container *ngIf="!tab">{{item.work_order_count}} {{item.work_order_count > 1 ? 'Jobs' : 'Job'}}</ng-container>
				</td>
				<td class="text-center">
					<div class="text-bold">{{item.quote_count}} {{item.quote_count === 1 ? 'quote' : 'quotes'}}</div>
					<div class="text-secondary">{{item.invoice_count}} {{item.invoice_count === 1 ? 'invoice' : 'invoices'}}</div>
				</td>
				<td>{{item.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}}</td>
				<td>
					{{item.modified_datetime | mySQLDateToISO | localizedDate:'shortDate'}}<br>
					<small class="text-secondary">{{item.modified_text}}</small>
				</td>
				<td class="shrink nowrap text-center">
					<span class="badge badge-{{statusColor(item.status)}} mr-1">{{statusDescription(item.status)}}</span>
				</td>
				<td class="shrink nowrap">
					<ng-container>
						<ng-container *ngFor="let s of item.statusList">
							<span *ngIf="!status.includes(s)" class="badge badge-{{statusColor(s)}} mr-1">{{statusDescription(s)}}</span>
						</ng-container>
					</ng-container>
					<div *ngIf="item.quote_count > 0" class="progress progress-sm mt-2">
						<div *ngIf="item.paid_total > 0" class="progress-bar bg-success" [style.width.%]="(item.paid_total / item.net_total) * 100" [ngbTooltip]="'Paid: ' + (item.paid_total | currency:item.currency_id)"></div>
						<div *ngIf="item.outstanding_total> 0" class="progress-bar bg-warning" [style.width.%]="(item.outstanding_total / item.net_total) * 100" [ngbTooltip]="'Unpaid: ' + (item.outstanding_total | currency:item.currency_id)"></div>
						<div *ngIf="item.draft_total > 0" class="progress-bar bg-info" [style.width.%]="(item.draft_total / item.net_total) * 100" [ngbTooltip]="'Draft: ' + (item.draft_total | currency:item.currency_id)"></div>
						<div *ngIf="item.not_invoiced_total > 0" class="progress-bar bg-silver" [style.width.%]="(item.not_invoiced_total / item.net_total) * 100" [ngbTooltip]="'Not invoiced: ' + (item.not_invoiced_total | currency:item.currency_id)"></div>
					</div>
				</td>
				<td>
					<ng-container *ngFor="let label_id of item.labels; let i = index">
						<div *ngIf="i < 2; else showMoreLabels">
							<ui-label [label_text]="getLabelData(label_id)?.text" [label_color]="getLabelData(label_id)?.label_color"></ui-label>
						</div>
						<ng-template #showMoreLabels>
							<div *ngIf="i === item.labels.length - 1">
								<span class="badge badge-secondary text-uppercase p-2" [ngbTooltip]="item.labels.length > 2 ? labelTooltip : null" style="background-color: #EDF0F3; font-size: 0.7rem; color: #000; margin-left: 2rem;">+{{ item.labels.length - 2 }}</span>
							</div>
							<ng-template #labelTooltip>
								<ng-container *ngFor="let labelid of item.labels; let j = index">
									<div *ngIf="j > 1;" style="text-align: left;">
										<ui-label [label_text]="getLabelData(labelid)?.text" [label_color]="getLabelData(labelid)?.label_color"></ui-label>
									</div>
								</ng-container>
							</ng-template>
						</ng-template>
					</ng-container>
				</td>
				<td class="text-right">
					<ng-container *ngIf="item.net_total !== null">
						{{item.net_total | currency:item.currency_id}}
					</ng-container>
				</td>
			</tr>
			<tr *ngIf="!pagination.count">
				<td colspan="7" class="text-secondary">No projects found.</td>
			</tr>
		</tbody>
	</table>
	<div class="flex-weight-1" ui-modal-footer>
		<app-pagination [pagination]="pagination"></app-pagination>
	</div>
	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button class="btn btn-primary ml-2" (click)="addProject()" ui-modal-footer>New Project</button>

</ui-modal>

<modal-edit-project (close)="editProjectModalClosed($event)"></modal-edit-project>
